import React from "react";
import injectSheet from "react-jss";

const TextButton = (props) => {
  const {
    classes,
    className,
    disabled,
    handleClick,
    handleKeyDown,
    index,
    text,
    primary,
  } = props;

  const onClick = !disabled && handleClick ? handleClick : () => false;
  const onKeyDown = !disabled && handleKeyDown ? handleKeyDown : () => false;

  return (
    <div
      className={`${classes.textButtonContainer} ${disabled && "disabled"} button`}
    >
      <div
        className={`${className} ${classes.textButton} ${primary && "primary"}`}
        style={props.buttonStyle}
        role="button"
        tabIndex={index}
        onClick={onClick}
        onKeyDown={onKeyDown}
      >
        <span className={`${classes.text}`}>{text}</span>
      </div>
    </div>
  );
};

const styles = (theme) => ({
  textButtonContainer: {
    padding: `0 ${theme.sizes.gutter / 2}px`,
    opacity: 1,
    cursor: "pointer",
    transition: [
      {
        property: "opacity",
        duration: theme.speed.fast,
      },
    ],
    "&.disabled": {
      cursor: "auto",
      opacity: 0,
    },
  },
  textButton: {
    height: "100%",
    backgroundColor: theme.colors.main_2,
    color: theme.colors.secondary_3b,
    borderColor: theme.colors.secondary_3b,
    borderWidth: "3px",
    borderStyle: "solid",
    borderRadius: "5px",
    padding: `${theme.sizes.gutter / 4}px ${theme.sizes.gutter / 2}px`,
    fontSize: "1em",
    display: "flex",
    alignItems: "center",
    [theme.media.medium]: {
      padding: `${theme.sizes.gutter / 4}px ${theme.sizes.gutter}px`,
    },
    transition: [
      {
        property: "color",
        duration: theme.speed.fast,
      },
      {
        property: "background-color",
        duration: theme.speed.fast,
      },
    ],
    "&:hover": {
      backgroundColor: theme.colors.secondary_3b,
      color: theme.colors.main_2,
    },
    "&.primary": {
      borderColor: theme.colors.main_1,
      backgroundColor: theme.colors.main_1,
      color: theme.colors.main_2,
      "&:hover": {
        backgroundColor: theme.colors.main_2,
        color: theme.colors.main_1,
      },
    },
  },
  text: {
    textAlign: "center",
    [theme.media.medium]: {
      textAlign: "left",
    },
  },
});

export default injectSheet(styles)(TextButton);



// WEBPACK FOOTER //
// ./src/modules/core/components/textButton.jsx